export const UPDATELOCATION_REQUEST = 'updatelocation/UPDATELOCATION_REQUEST';
export const UPDATELOCATION_RESPONSE = 'updatelocation/UPDATELOCATION_RESPONSE';
export const HIDE_MODAL = 'profile/HIDE_MODAL';
